var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceHappy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1605_73560)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4993 7.4974H12.5077M7.49935 7.4974H7.50768M18.3327 9.9974C18.3327 14.5998 14.6017 18.3307 9.99935 18.3307C5.39698 18.3307 1.66602 14.5998 1.66602 9.9974C1.66602 5.39502 5.39698 1.66406 9.99935 1.66406C14.6017 1.66406 18.3327 5.39502 18.3327 9.9974ZM12.916 7.4974C12.916 7.72751 12.7295 7.91406 12.4993 7.91406C12.2692 7.91406 12.0827 7.72751 12.0827 7.4974C12.0827 7.26728 12.2692 7.08073 12.4993 7.08073C12.7295 7.08073 12.916 7.26728 12.916 7.4974ZM7.91602 7.4974C7.91602 7.72751 7.72947 7.91406 7.49935 7.91406C7.26923 7.91406 7.08268 7.72751 7.08268 7.4974C7.08268 7.26728 7.26923 7.08073 7.49935 7.08073C7.72947 7.08073 7.91602 7.26728 7.91602 7.4974ZM9.99935 14.5807C12.0831 14.5807 13.7493 13.0532 13.7493 11.6641H6.24935C6.24935 13.0532 7.9156 14.5807 9.99935 14.5807Z",
    stroke: "#22B7A5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1605_73560"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceHappy);
export default __webpack_public_path__ + "static/media/face-happy.defc46076c00122f717e992091a0063e.svg";
export { ForwardRef as ReactComponent };